import { useTranslation } from "react-i18next";

import { getShopifyLabelFromError } from "~/utils/shopify";
import type { ShopifyErrorCode } from "~/utils/shopify";

export const OrderShopifyErrorList: React.FC<{
  shopifyDesyncErrors: Record<ShopifyErrorCode, string>;
}> = ({ shopifyDesyncErrors }) => {
  const { t } = useTranslation();
  return (
    <ul className="list-inside list-disc whitespace-pre-line text-sm text-gray-700">
      {Object.entries(shopifyDesyncErrors)
        .filter(([_, value]) => value)
        .map(([error, value]) => (
          <li key={error}>{getShopifyLabelFromError(+error, t, value)}</li>
        ))}
    </ul>
  );
};
